import { BTLCalcResultsPage } from '@dreamstack/accentro-contentful/src/blocks/CustomBlocks/BuyToLetCalculator/BTLCalcResultsPage'
import { StaticPage } from '@dreamstack/accentro-contentful/src/components/StaticPage'
import { HeadingH1 } from '@dreamstack/feature-components/src/layout/Texts'
import { fetchStaticPageData } from '@dreamstack/payload/src/lib/fetchStaticPageData'
import { getStaticPropsPlus } from '../lib/next/getStaticPropsPlus'

export default function BtlResults() {
  return (
    <StaticPage slug={'btl-calc-results-footer'}>
      <HeadingH1>Buy-To-Let Calculator results</HeadingH1>
      <BTLCalcResultsPage />
    </StaticPage>
  )
}

export const getStaticProps = getStaticPropsPlus({
  getProps: async () => {
    await fetchStaticPageData({ slug: 'btl-calc-results-footer' })
  },
})
